var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 5a4.086 4.086 0 0 0-4.083 4.083A4.086 4.086 0 0 0 12 13.167a4.086 4.086 0 0 0 4.083-4.084A4.086 4.086 0 0 0 12 5m0 1.167A2.918 2.918 0 0 1 12 12a2.918 2.918 0 0 1 0-5.833",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19 17.833c0-1.547-.738-3.03-2.05-4.124C15.637 12.614 13.856 12 12 12s-3.637.614-4.95 1.709C5.738 14.802 5 16.286 5 17.833v.584c0 .322.314.583.7.583h12.6c.386 0 .7-.261.7-.583zm-1.4 0c0-1.237-.59-2.424-1.64-3.3s-2.475-1.366-3.96-1.366-2.91.491-3.96 1.367c-1.05.875-1.64 2.062-1.64 3.3z",
    clipRule: "evenodd"
  })));
};
export default SvgUser;